import React from 'react';
import { useRouteMatch, Switch, Route, Link } from 'react-router-dom';
import CurrentExhibitionList from './exhibition-list';
import UpcomingExhibitionList from './exhibition-upcoming-list'
import ExhibitionDetail from './exhibition-detail'
import ExhibitionEdit from '../Admin/Exhibition/edit-exhibition'



function Exhibition(){
    return(
        <div>
        <div className='flex_exhibition'>
            <div className='exhibitionLeft'>
            <Switch>
            <Route  path='/exhibitions/current/list/:tag'><CurrentExhibitionList/></Route>
            <Route  path='/exhibitions/upcoming/list/:tag'><UpcomingExhibitionList/></Route>
            </Switch>
            </div>

            <div className='exhibitionRight'>
             <Route path='/exhibitions/current/list/all/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/contemporary_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/modern_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/classic_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/ancient_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/applied_fine_arts/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/photograph/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/isRecommendation/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/current/list/isFreeAdmission/detail/:id'><ExhibitionDetail/></Route> 
        
             <Route path='/exhibitions/upcoming/list/all/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/contemporary_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/modern_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/classic_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/ancient_art/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/applied_fine_arts/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/photograph/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/isRecommendation/detail/:id'><ExhibitionDetail/></Route> 
             <Route path='/exhibitions/upcoming/list/isFreeAdmission/detail/:id'><ExhibitionDetail/></Route> 
            </div>
        </div>
        </div>
    )

}

export default Exhibition;